export default __webpack_public_path__ + "static/media/detail_small_2_3.bc53cc2a.png";